<div class="checkout-product-container">
    @for (productLine of products ?? []; track $index) {
        <div class="checkout-card-container">
            <div class="primary-info">
                <a [routerLink]="productLine.mhpId ? (productLine.product?.sourcePrebuiltPackId ? [PACK_ROUTE, productLine.product.sourcePrebuiltPackId] : [MHP_BUILD_ROUTE]) : [PRODUCT_ROUTE, ProductUtil.convertUsanaIdToDash(productLine.product.usanaId)]"
                   [queryParams]="productLine.mhpId && !productLine.product?.sourcePrebuiltPackId ? {type: 'edit', packId: productLine.mhpId} : {}">
                    <product-image imageType="productImage"
                                   imageSize="XS" [images]="productLine.product.productImages"
                                   [imageAltText]="productLine?.product?.productDescription?.name"></product-image>
                </a>
                <div class="product-details-container">
                    <div class="flex-col">
                        <a class="heading-5"
                           [routerLink]="productLine.mhpId ? (productLine.product?.sourcePrebuiltPackId ? [PACK_ROUTE, productLine.product.sourcePrebuiltPackId] : [MHP_BUILD_ROUTE]) : [PRODUCT_ROUTE, ProductUtil.convertUsanaIdToDash(productLine.product.usanaId)]"
                           [queryParams]="productLine.mhpId && !productLine.product?.sourcePrebuiltPackId ? {type: 'edit', packId: productLine.mhpId} : {}"
                           [innerHTML]="productLine.product.productDescription.name"></a>
                        <p class="product-price">
                            @if (showRetailPriceStrikethrough(productLine)) {
                                <span class="featured-retail-price retail-price margin-right-4">{{ productLine.product.retailPrice.price | usanacurrency | async }}</span>
                                <span class="product-actual-price">{{ getProductPrice(productLine) | usanacurrency | async }}</span>
                            } @else {
                                {{ getProductPrice(productLine) | usanacurrency | async }}
                            }
                        </p>
                        @if (shouldDisplayVolume) {
                            <p class="product-volume">
                                {{ 'cart.product.recommended.volume' | translate }} {{ productLine.product.price.volume }}
                            </p>
                        }
                        <fs-not-eligible [product]="productLine.product"></fs-not-eligible>
                    </div>
                    <div class="checkout-card-quantity">
                        <div class="quantity-container">
                            <button type="button" [attr.aria-label]="'cart.overview.quantity.remove.one.label' | translate"
                                    class="cart-minus-button"
                                    [disabled]="productLine.quantity < 2 || productLine.product.id == busyProductId || !productLine.product.editable"
                                    (click)="decrement(productLine)"><i class="fa-solid fa-minus" aria-hidden="true"></i>
                            </button>
                            <input class="cart-quantity-input"
                                   [(ngModel)]="productLine.quantity"
                                   (keyup)="onKeyup(productLine)"
                                   (focus)="onFocus(productLine)"
                                   (onDebounce)="onChange(productLine)"
                                   [debounceTime]="500"
                                   type="text"
                                   [attr.aria-label]="'cart.overview.quantity.label' | translate"
                                   value="{{productLine.quantity}}"
                                   [disabled]="!productLine.product.editable || !productLine.product.removable"
                                   (blur)="onBlur(productLine)"/>
                            <button type="button" [attr.aria-label]="'cart.overview.quantity.add.one.label' | translate"
                                    class="cart-plus-button"
                                    [disabled]="productLine.product.id == busyProductId || !productLine.product.editable"
                                    (click)="increment(productLine)"><i
                                class="fa-solid fa-plus" aria-hidden="true"></i></button>
                        </div>
                    </div>
                </div>
                <div class="summary-action-wrapper">
                    <span class="summary-main-row">
                        @if (isAoUpsell) {
                            @if (canAddToAoUpsell(productLine) && productLine.subscribed) {
                                <span class="ao-upsell-status order-1">
                                    <i class="fa-solid fa-rotate margin-right-4" aria-hidden="true"></i>
                                    <span translate="cart.overview.product.ao.included"></span>
                                </span>
                            }
                            @if (!canAddToAoUpsell(productLine)) {
                                <span class="ao-upsell-status order-1"
                                      translate="cart.overview.product.ao.unavailable"></span>
                            }
                        }

                        <span class="summary-action-container">
                            @if (isAoUpsell && canAddToAoUpsell(productLine)) {
                                @if (productLine.subscribed) {
                                    <a href="javascript:void(0)" (click)="removeAoUpsell(productLine)"
                                       class="cart-product-summary-action ao-upsell-action order-2"
                                       translate="cart.overview.product.unsubscribe"></a>
                                } @else {
                                    <a href="javascript:void(0)" (click)="addAoUpsell(productLine)"
                                       class="cart-product-summary-action ao-upsell-action order-2"
                                       translate="cart.overview.product.subscribe"></a>
                                }
                            }
                            @if (allowCartSaveForLater && productLine.product.editable && productLine.product.removable) {
                                <a href="javascript:void(0)" (click)="productSaveForLater(productLine)"
                                   class="cart-product-summary-action order-3" translate='cart.product.save.for.later'></a>
                            }
                        </span>
                    </span>
                    @if (showProductExclusiveTag(productLine)) {
                        <span class="product-exclusive-tag" [translate]="'cart.overview.product.exclusive.' + customerType"></span>
                    }
                </div>
            </div>
            <i [attr.aria-label]="'cart.button.close'| translate" class="fa-solid fa-xmark"
               (click)="onRemove(productLine)"></i>
        </div>
    }
</div>
